/** Bytes legibles. Base 1024, que es la que usan los sistemas de archivos. */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'

  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  const value = bytes / 1024 ** exponent

  /*
   | El decimal sólo aparece cuando aporta algo.
   |
   | Los planes son cifras redondas, y «200.0 GB» en una tabla de precios hace
   | que un plan parezca una medición de laboratorio en vez de lo que compras.
   | Con 3 cifras enteras el decimal tampoco informa —nadie decide nada entre
   | 512,3 y 512,4 MB— y además desalinea la columna.
   */
  const decimals = exponent === 0 || value >= 100 || Number.isInteger(value) ? 0 : 1

  return `${value.toFixed(decimals)} ${units[exponent]}`
}

/**
 * Duración legible de un vídeo, a partir de los milisegundos que guarda el
 * pipeline de medios.
 *
 * `m:ss` hasta la hora y `h:mm:ss` a partir de ahí, que es como lo escribe todo
 * reproductor y como lo lee cualquiera sin pensarlo. Se redondea hacia abajo:
 * un vídeo de 59,6 s es «0:59», no «1:00» — decir que dura un minuto uno que
 * no llega es la clase de detalle que hace dudar del resto de la ficha.
 */
export function formatDuration(ms: number): string {
  const total = Math.floor(ms / 1000)
  const horas = Math.floor(total / 3600)
  const minutos = Math.floor((total % 3600) / 60)
  const segundos = total % 60

  const dosCifras = (n: number): string => n.toString().padStart(2, '0')

  return horas > 0
    ? `${horas}:${dosCifras(minutos)}:${dosCifras(segundos)}`
    : `${minutos}:${dosCifras(segundos)}`
}
